import RemoteChart from '@webtrader-chart/remote';

import { IProfitsStatistics } from '@aqx-core/common/api/statistics';
import storage, { EStorageKey } from '@aqx-core/common/storage';
import { appThemeService, getThemeColors } from '@aqx-core/common/theme';

import { EChartType, EEventMessageType } from '../../trade/analysis/equity-chart';

class ProfitLossChartViewController {
  private remoteChart?: RemoteChart;

  public init = async (profitsStatistic: IProfitsStatistics[]) => {
    let RemoteChartModule;
    try {
      RemoteChartModule = await import('@webtrader-chart/remote');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn('Remote chart module not available:', err);
      return;
    }
    const RemoteChart = RemoteChartModule.default;
    const remoteChart = new RemoteChart();
    remoteChart.init({
      token: storage.getItem(EStorageKey.TOKEN),
      type: EChartType.PROFIT_LOSS,
      profitsStatistic,
      colors: appThemeService.context.theme.themeColors
    });

    this.remoteChart = remoteChart;
    postMessage(
      {
        type: EEventMessageType.THEME_SCHEME,
        data: appThemeService.context.theme.themeColors
      },
      '*'
    );
  };

  public reset = () => {
    this.remoteChart?.reset();
    this.remoteChart = undefined;
  };

  public updateChartTheme = () => {
    if (!this.remoteChart) {
      return;
    }

    postMessage(
      {
        type: EEventMessageType.THEME_SCHEME,
        data: getThemeColors()
      },
      '*'
    );
  };
}

export const profitLossChartViewController = new ProfitLossChartViewController();
